export default __webpack_public_path__ + "static/majewski-3b479e21f2aa7381d0d804809cfe0b81.jpg";